import { ReasonTag, TsTag } from "../../../../src/components/LanguageTag.js";
import { Ad } from "../../../../src/components/Ad.js";
import * as React from 'react';
export default {
  ReasonTag,
  TsTag,
  Ad,
  React
};